/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteLocationsParams,
  GetLocationsParams,
  Locations,
  LocationsInsertPayload,
  LocationsUpdate,
  PatchLocationsParams,
  PostLocationsParams,
  PostgrestError
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getLocationsResponse200 = {
  data: Locations[]
  status: 200
}

export type getLocationsResponse206 = {
  data: Locations[]
  status: 206
}

export type getLocationsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getLocationsResponseSuccess = (getLocationsResponse200 | getLocationsResponse206) & {
  headers: Headers;
};
export type getLocationsResponseError = (getLocationsResponseDefault) & {
  headers: Headers;
};

export type getLocationsResponse = (getLocationsResponseSuccess | getLocationsResponseError)

export const getGetLocationsUrl = (params?: GetLocationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/locations?${stringifiedParams}` : `${backendBaseUrl}/locations`
}

/**
 * @summary Read rows from `locations`.
 */
export const getLocations = async (params?: GetLocationsParams, options?: RequestInit): Promise<getLocationsResponse> => {

  const res = await fetch(getGetLocationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getLocationsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getLocationsResponse
}


export type postLocationsResponse201 = {
  data: Locations[]
  status: 201
}

export type postLocationsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postLocationsResponseSuccess = (postLocationsResponse201) & {
  headers: Headers;
};
export type postLocationsResponseError = (postLocationsResponseDefault) & {
  headers: Headers;
};

export type postLocationsResponse = (postLocationsResponseSuccess | postLocationsResponseError)

export const getPostLocationsUrl = (params?: PostLocationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/locations?${stringifiedParams}` : `${backendBaseUrl}/locations`
}

/**
 * @summary Insert one or more rows into `locations`.
 */
export const postLocations = async (locationsInsertPayload: LocationsInsertPayload,
    params?: PostLocationsParams, options?: RequestInit): Promise<postLocationsResponse> => {

  const res = await fetch(getPostLocationsUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(locationsInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postLocationsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postLocationsResponse
}


export type patchLocationsResponse200 = {
  data: Locations[]
  status: 200
}

export type patchLocationsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchLocationsResponseSuccess = (patchLocationsResponse200) & {
  headers: Headers;
};
export type patchLocationsResponseError = (patchLocationsResponseDefault) & {
  headers: Headers;
};

export type patchLocationsResponse = (patchLocationsResponseSuccess | patchLocationsResponseError)

export const getPatchLocationsUrl = (params?: PatchLocationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/locations?${stringifiedParams}` : `${backendBaseUrl}/locations`
}

/**
 * @summary Update the rows of `locations` matching the given filters.
 */
export const patchLocations = async (locationsUpdate: LocationsUpdate,
    params?: PatchLocationsParams, options?: RequestInit): Promise<patchLocationsResponse> => {

  const res = await fetch(getPatchLocationsUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(locationsUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchLocationsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchLocationsResponse
}


export type deleteLocationsResponse200 = {
  data: Locations[]
  status: 200
}

export type deleteLocationsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteLocationsResponseSuccess = (deleteLocationsResponse200) & {
  headers: Headers;
};
export type deleteLocationsResponseError = (deleteLocationsResponseDefault) & {
  headers: Headers;
};

export type deleteLocationsResponse = (deleteLocationsResponseSuccess | deleteLocationsResponseError)

export const getDeleteLocationsUrl = (params?: DeleteLocationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/locations?${stringifiedParams}` : `${backendBaseUrl}/locations`
}

/**
 * @summary Delete the rows of `locations` matching the given filters.
 */
export const deleteLocations = async (params?: DeleteLocationsParams, options?: RequestInit): Promise<deleteLocationsResponse> => {

  const res = await fetch(getDeleteLocationsUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteLocationsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteLocationsResponse
}


